export const ROLES = {
  SUPER_ADMIN: '1',
  ADMIN: '2',
  USER: '3',
};

export const UserDetails = [
  {
    email: 'superadmin@gmail.com',
    user_name: 'Super Admin',
    company_name: 'KRM - Super Admin',
    mobile: '9876543210',
    password: 'User@123',
    role: ROLES.SUPER_ADMIN,
  },
  {
    email: 'admin@gmail.com',
    user_name: 'Admin',
    company_name: 'KRM - Admin',
    mobile: '9876543210',
    password: 'User@123',
    role: ROLES.ADMIN,
  },
  {
    email: 'user@gmail.com',
    user_name: 'User',
    company_name: 'KRM - User',
    mobile: '9876543210',
    password: 'User@123',
    role: ROLES.USER,
  },
];

export const currentUser = () => JSON.parse(localStorage.getItem('user'));
